/* eslint-disable max-len */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EntryMethodPreferencesPayload } from '@acp/shared';
import { updatePropertyEntryMethodPreference } from '../../../property/service';

type UseEntryMethodOpts = {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
};

function useEntryMethodMutation(
    propertyId: string | number,
    opts: UseEntryMethodOpts = {}
) {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: (preferences: EntryMethodPreferencesPayload) => updatePropertyEntryMethodPreference(propertyId, preferences),
        onSuccess: () => {
            void queryClient.invalidateQueries({
                queryKey: ['entry-method-preferences', propertyId],
            });

            void queryClient.removeQueries({
                queryKey: ['entry-method-preferences', propertyId],
            });

            if (opts.onSuccess !== undefined) {
                opts.onSuccess();
            }
        },
        onError: (error) => {
            if (opts.onError !== undefined) {
                opts.onError(error);
            }
        },
    });

    return query;
}

export { useEntryMethodMutation };
